import type { RegexExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const regexResolver =
  createSimpleNamedExpressionResolver<RegexExpression>(
    'regex',
    (value, regex) => value.match(regex) !== null
  );
